import { render, staticRenderFns } from "./SkillRatingsToValidateWidget.vue?vue&type=template&id=46bb2212&scoped=true"
import script from "./SkillRatingsToValidateWidget.vue?vue&type=script&lang=js"
export * from "./SkillRatingsToValidateWidget.vue?vue&type=script&lang=js"
import style0 from "./SkillRatingsToValidateWidget.vue?vue&type=style&index=0&id=46bb2212&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb2212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46bb2212')) {
      api.createRecord('46bb2212', component.options)
    } else {
      api.reload('46bb2212', component.options)
    }
    module.hot.accept("./SkillRatingsToValidateWidget.vue?vue&type=template&id=46bb2212&scoped=true", function () {
      api.rerender('46bb2212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/SkillRatingsToValidateWidget.vue"
export default component.exports